var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAttachmentClient } from '@juvare/platform-sdk-react/ui/hooks';
export const useGetSelectedFilesContent = () => {
    const attachmentsClient = useAttachmentClient();
    const downloadFile = (_a) => __awaiter(void 0, [_a], void 0, function* ({ currentVersionId, name }) {
        const { content, contentType } = yield attachmentsClient.getContent({
            entity: 'documentLibraryFileVersion',
            entityId: currentVersionId,
            key: 'data',
        });
        return new File([content], name, { type: contentType });
    });
    return (selectedFiles) => {
        const files = [];
        for (const { currentVersionId, name } of selectedFiles) {
            if (currentVersionId) {
                files.push(downloadFile({ currentVersionId, name }));
            }
        }
        return Promise.all(files);
    };
};
